import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as moment from "moment";
import "moment-timezone";
import { deleteUserById, userList } from "../../../services/userservice";
import {
  setLoading as setUserLoading,
  setUsers,
  addUser,
  setEditingUserId,
  updateUser,
  deleteUser,
  setError,
  setEditingUser,
} from "../../../features/common/userSlice";

const Transaction = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showToaster, setShowToaster] = useState(false);
  const { users, loading, error } = useSelector((state) => state.user);

  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(setUserLoading());
        const response = await userList();
        console.log("response", response);
        dispatch(setUsers(response));
      } catch (error) {
        dispatch(setError(error.message));
      }
    };
    fetchData();
  }, [dispatch]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleDelete = async (userId) => {
    // Here, you can prompt the user for confirmation before deleting
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        const deleteResponse = await deleteUserById(userId);
        console.log("deleteResponse", deleteResponse.message);
        if (deleteResponse.status === 200 || deleteResponse.status === 201) {
          dispatch(deleteUser(userId));
          // setShowToaster(true);
          // setToasterMessage('Coupon deleted successfully!');
          // setTimeout(() => {
          //   setShowToaster(false);
          //   setToasterMessage('');
          // }, 3000)
        } else {
          //dispatch(setError(error.message))
          dispatch(setError(deleteResponse.message || "Failed to delete user"));
        }
      } catch (error) {
        alert("You are not authorize to delete this user");
        //dispatch(setErrorMessage(error.message || 'You are not authorize to delete this user'));
      }
    }
  };

  if (loading) return <div>Loading...</div>; // Render a loading message

  if (error) return <div>Error: {error}</div>; // Render an error message

  const filteredUsers = users.filter(
    (user) =>
      user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Users</h1>
            </div>
            {/* /.col */}
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div classname="row">
            <div classname="card-body">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">{/* <b>User List</b> */}</h3>
                  <div className="d-flex align-items-center justify-content-end">
                    <div className="mr-3">
                      <Link to="/add-user">
                        <button type="button" className="btn btn-primary">
                          <i className="fas fa-plus" /> Add User
                        </button>
                      </Link>
                    </div>
                    <div className="card-tools">
                      <div
                        className="input-group input-group-sm"
                        style={{ width: "250px" }}
                      >
                        <input
                          type="text"
                          name="table_search"
                          className="form-control float-right"
                          placeholder="Search"
                          // value={searchTerm}
                          // onChange={handleSearchChange}
                        />
                        <div className="input-group-append">
                          <button type="submit" className="btn btn-default">
                            <i className="fas fa-search" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body p-0">
                  <table className="table table-striped projects">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone Number</th>
                        <th>User Type</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredUsers.map((user) => (
                        <tr key={user.id}>
                          <td>{user.id}</td>
                          <td>{user.firstName}</td>
                          <td>{user.email}</td>
                          <td>{user.phone_no}</td>
                          <td>{user.user_type}</td>

                          <td>
                            <span
                              className={`badge p-2 w-100 ${
                                user.status === "active"
                                  ? "badge-success"
                                  : "badge-danger"
                              }`}
                            >
                              {user.status.toUpperCase()}
                            </span>
                          </td>
                          <td>
                            <Link to={`/edit-user/${user.id}`}>
                              <button className="btn btn-primary btn-sm">
                                Edit
                              </button>
                            </Link>
                            &nbsp;&nbsp;
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => handleDelete(user.id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Transaction;
